/* projects/speaker-platform/src/app/molecules/pagination/pagination.component.scss */
/*# sourceMappingURL=pagination.component-6MQWTBTA.css.map */
